<div class="guest bg-white">
   <router-outlet></router-outlet>
</div>
